<ea-group [context]="this" [group]="group"></ea-group>
